import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router/immutable'

// import React DnD
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { TouchBackend } from 'react-dnd-touch-backend'

import * as detectIt from 'detect-it'

import App from '../App'

// create backend for react-dnd (could be MultiBackend, HTML5Backend, TouchBackend etc.)
const dndBackend = detectIt.deviceType === 'touchOnly' ? TouchBackend : HTML5Backend

class Root extends Component {
    static propTypes = {
        history: PropTypes.object.isRequired,
        store: PropTypes.object.isRequired,
    }

    render() {
        const { store, history } = this.props

        return (
            <Provider store={store}>
                <DndProvider backend={dndBackend}>
                    <ConnectedRouter history={history}>
                        <App />
                    </ConnectedRouter>
                </DndProvider>
            </Provider>
        )
    }
}

export default Root
